<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_VARIANTS } from '../constants';

const { attachments, variant } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

const isAgentVariant = computed(() => variant.value === MESSAGE_VARIANTS.AGENT);
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <AudioChip
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
      :class="
        isAgentVariant ? 'bg-[#d6f0e4] dark:bg-n-teal-4' : 'bg-n-alpha-white'
      "
    />
  </BaseBubble>
</template>
